export default "__VITE_ASSET__122ff6b8__"